import { supabase, supabaseAdmin } from '../lib/supabaseClient';

type DriverRow = {
  id: string;
  full_name: string | null;
  phone: string | null;
  vehicle_info: string | null;
  is_online: boolean;
  push_token: string | null;
  last_seen_at: string | null;
  created_at: string;
  updated_at: string;
};

export interface DriverRecord {
  id: string;
  fullName: string | null;
  phone: string | null;
  vehicleInfo: string | null;
  isOnline: boolean;
  pushToken: string | null;
  lastSeenAt: string | null;
  createdAt: string;
  updatedAt: string;
}

const client = supabaseAdmin ?? supabase;

const mapDriver = (row: DriverRow): DriverRecord => ({
  id: row.id,
  fullName: row.full_name,
  phone: row.phone,
  vehicleInfo: row.vehicle_info,
  isOnline: Boolean(row.is_online),
  pushToken: row.push_token,
  lastSeenAt: row.last_seen_at,
  createdAt: row.created_at,
  updatedAt: row.updated_at,
});

export async function listDrivers(): Promise<DriverRecord[]> {
  const { data, error } = await client
    .from('drivers')
    .select('*')
    .order('updated_at', { ascending: false });

  if (error) {
    throw error;
  }

  return (data ?? []).map(mapDriver);
}

export interface UpsertDriverInput {
  id?: string;
  fullName?: string | null;
  phone?: string | null;
  vehicleInfo?: string | null;
  isOnline?: boolean;
  pushToken?: string | null;
}

export async function upsertDriver(input: UpsertDriverInput): Promise<DriverRecord> {
  const payload = {
    full_name: input.fullName ?? null,
    phone: input.phone ?? null,
    vehicle_info: input.vehicleInfo ?? null,
    is_online: input.isOnline ?? false,
    push_token: input.pushToken ?? null,
    updated_at: new Date().toISOString(),
  };

  const query = client
    .from('drivers')
    .upsert(input.id ? [{ ...payload, id: input.id }] : [payload], { onConflict: 'id' })
    .select()
    .single();

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return mapDriver(data as DriverRow);
}

export async function deleteDriver(driverId: string) {
  const { error } = await client.from('drivers').delete().eq('id', driverId);
  if (error) {
    throw error;
  }
}
